// src/components/theme/theme_provider.tsx
"use client";

import { useEffect } from "react";
import { ThemeProvider as NextThemesProvider, useTheme as useNextTheme } from "next-themes";

type Props = {
	children: React.ReactNode;
};

export function ThemeProvider({ children }: Props) {
	useEffect(() => {
		const doc = document.documentElement;
		doc.classList.add("theme-mounted");
		// re-enable transitions after first paint to avoid initial flash
		const timer = window.setTimeout(() => {
			doc.classList.remove("theme-no-transition");
		}, 0);
		return () => {
			window.clearTimeout(timer);
			doc.classList.remove("theme-mounted");
		};
	}, []);

	return (
		<NextThemesProvider
			attribute="data-theme"
			defaultTheme="system"
			enableSystem
			storageKey="theme"
			enableColorScheme={true}
			disableTransitionOnChange={false}
		>
			{children}
		</NextThemesProvider>
	);
}

export const useTheme = useNextTheme;
